<ng-container *ngIf="gatewayStore.assignableDevicesFlag$ | async as flag">
  <div
    *ngIf="gatewayStore.assignableDevices$ | async as assignableDevices"
    class="flex flex-col gap-[24px]"
  >
    <div class="flex flex-row justify-between items-center">
      <div class="flex flex-row gap-[24px] lt-md:gap-[16px] justify-start items-center">
        <mat-icon>menu</mat-icon>
        <h3 class="app-ellipsis">{{ room?.properties?.name?.value }}</h3>
      </div>
      <div class="button-wrapper">
        <button
          mat-stroked-button
          color="primary"
          gtm="onOpen"
          gtmAction="Edit room modal"
          gtmCategory="room"
          (click)="onEditRoom()"
        >
          <mat-icon>edit</mat-icon>
          <span>{{ 'GENERAL.BUTTON.EDIT' | translate }}</span>
        </button>
      </div>
    </div>

    <div *ngIf="areDevicesAssignedToRoom(room); else noDevicesEl">
      <div class="offset src-devices-grid">
        <ng-container
          *ngIf="
            installationFeaturesStore.getDevicesOfChosenTypeAssignedToTheRoom(roomId, srcType.CS)
              | async as devices
          "
        >
          <app-src-device-panel
            *ngFor="let device of devices"
            [device]="device"
            [roomId]="room.feature"
            [heatingCircuitIdFeature$]="heatingCircuitId$[device.deviceId]"
            (unassignDevice)="onUnassignDeviceFromRoom($event)"
          >
          </app-src-device-panel>
        </ng-container>

        <ng-container
          *ngIf="
            installationFeaturesStore.getDevicesOfChosenTypeAssignedToTheRoom(roomId, srcType.TRV)
              | async as devices
          "
        >
          <app-src-device-panel
            *ngFor="let device of devices"
            [device]="device"
            [roomId]="room.feature"
            [heatingCircuitIdFeature$]="heatingCircuitId$[device.deviceId]"
            (unassignDevice)="onUnassignDeviceFromRoom($event)"
          >
          </app-src-device-panel>
        </ng-container>

        <ng-container
          *ngIf="
            installationFeaturesStore.getDevicesOfChosenTypeAssignedToTheRoom(
              roomId,
              srcType.FHT_CHANNEL
            ) | async as devices
          "
        >
          <app-src-device-panel
            *ngFor="let device of devices"
            [device]="device"
            [roomId]="room.feature"
            [heatingCircuitIdFeature$]="heatingCircuitId$[device.deviceId]"
            (unassignDevice)="onUnassignDeviceFromRoom($event)"
          >
          </app-src-device-panel>
        </ng-container>
        <ng-container
          *ngIf="
            installationFeaturesStore.getDevicesOfChosenTypeAssignedToTheRoom(
              roomId,
              srcType.VITOTROL_300E
            ) | async as devices
          "
        >
          <app-src-device-panel
            *ngFor="let device of devices"
            [device]="device"
            [roomId]="room.feature"
            [heatingCircuitIdFeature$]="heatingCircuitId$[device.deviceId]"
            (unassignDevice)="onUnassignDeviceFromRoom($event)"
          >
          </app-src-device-panel>
        </ng-container>
        <ng-container
          *ngIf="
            installationFeaturesStore.getDevicesOfChosenTypeAssignedToTheRoom(
              roomId,
              srcType.AIR_QUALITY_SENSOR
            ) | async as devices
          "
        >
          <app-src-device-panel
            *ngFor="let device of devices"
            [device]="device"
            [roomId]="room.feature"
            [heatingCircuitIdFeature$]="heatingCircuitId$[device.deviceId]"
            (unassignDevice)="onUnassignDeviceFromRoom($event)"
          >
          </app-src-device-panel>
        </ng-container>
      </div>

      <div class="flex flex-row justify-start items-center">
        <button
          class="add-device-btn"
          mat-stroked-button
          color="primary"
          gtm="onOpen"
          gtmAction="Edit room modal"
          gtmCategory="room"
          (click)="openManageRoomDialog(room)"
        >
          <mat-icon>add</mat-icon>
          <span>{{ '+COMMISSIONING.BUTTON.ADD_DEVICE_OR_CHANNEL' | translate }}</span>
        </button>
      </div>
    </div>

    <ng-template #noDevicesEl>
      <div
        class="offset flex flex-row gap-[16px]"
        [ngSwitch]="!flag.empty && (room | executable: 'addActor')"
      >
        <button
          *ngSwitchCase="true"
          mat-stroked-button
          color="primary"
          gtm="onOpen"
          gtmAction="Edit room modal"
          gtmCategory="room"
          (click)="openManageRoomDialog(room)"
        >
          <mat-icon>add</mat-icon>
          <span>{{ '+COMMISSIONING.BUTTON.ADD_DEVICE_OR_CHANNEL' | translate }}</span>
        </button>
        <button
          *ngSwitchCase="false"
          data-at-comissioning-room-btn-add-device
          mat-stroked-button
          color="primary"
          gtm="onOpen"
          gtmAction="Add device or channel to room confirmation dialog"
          gtmCategory="room"
          [viConfirm]="{
            title: '+COMMISSIONING.NO_ADDED_DEVICES.CONFIRM.TITLE' | translate,
            content: '+COMMISSIONING.NO_ADDED_DEVICES.CONFIRM.CONTENT' | translate,
            cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
            confirmBtn: 'GENERAL.BUTTON.ADD_DEVICE' | translate
          }"
          (confirm)="onAddDevice()"
          (cancel)="gtmService.track('onCancel', 'Add device or channel confirmation', 'room')"
        >
          <mat-icon>add</mat-icon>
          <span>{{ '+COMMISSIONING.BUTTON.ADD_DEVICE_OR_CHANNEL' | translate }}</span>
        </button>
      </div>
    </ng-template>
  </div>
</ng-container>
